"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = InlineWeekHoursEditor;
const react_1 = __importStar(require("react"));
const ScrumboardApi_1 = __importDefault(require("../ScrumboardApi"));
const DAYS = [
    { key: "hoursMon", placeholder: "PO" },
    { key: "hoursTue", placeholder: "WT" },
    { key: "hoursWed", placeholder: "ŚR" },
    { key: "hoursThu", placeholder: "CZ" },
    { key: "hoursFri", placeholder: "PT" },
];
function weekSum(task) {
    return DAYS.reduce((sum, d) => sum + (Number(task[d.key]) || 0), 0);
}
/** Indeks dzisiejszego dnia roboczego (PO=0 … PT=4); w weekend fallback na poniedziałek. */
function todayDayIndex() {
    const day = new Date().getDay(); // 0=niedz, 1=pon … 6=sob
    return day >= 1 && day <= 5 ? day - 1 : 0;
}
/** Czas rzeczywisty PO-PT: klik w sumę → 5 pól rozsuwa się (animacja); Enter/blur poza obszar → zapis. */
function InlineWeekHoursEditor({ task, onSaved }) {
    const [editing, setEditing] = (0, react_1.useState)(false);
    const [saving, setSaving] = (0, react_1.useState)(false);
    const [values, setValues] = (0, react_1.useState)({});
    const containerRef = (0, react_1.useRef)(null);
    const focusInputRef = (0, react_1.useRef)(null);
    // Tuż po otwarciu potrafi wpaść przejściowy blur (relatedTarget=null) w trakcie animacji
    // — ignorujemy go, żeby edytor nie zwijał się od razu (i nie robił pustego zapisu).
    const justOpenedRef = (0, react_1.useRef)(false);
    const todayIdx = todayDayIndex();
    (0, react_1.useEffect)(() => {
        if (!editing)
            return;
        const initial = {};
        for (const d of DAYS)
            initial[d.key] = task[d.key] != null ? String(task[d.key]) : "";
        setValues(initial);
        justOpenedRef.current = true;
        const timer = setTimeout(() => (justOpenedRef.current = false), 350);
        requestAnimationFrame(() => focusInputRef.current?.focus());
        return () => clearTimeout(timer);
    }, [editing]);
    async function save() {
        const payload = {};
        for (const d of DAYS) {
            const raw = values[d.key];
            const parsed = raw == null || raw.trim() === "" ? null : Number(raw);
            if (parsed != null && (Number.isNaN(parsed) || parsed < 0))
                return;
            payload[d.key] = parsed;
        }
        try {
            setSaving(true);
            const result = await ScrumboardApi_1.default.updateTaskHours(task.id, payload);
            onSaved(result);
        }
        catch (err) {
            console.error("Błąd zapisu godzin dziennych:", err);
        }
        finally {
            setSaving(false);
            setEditing(false);
        }
    }
    function handleBlur(e) {
        if (justOpenedRef.current)
            return; // przejściowy blur w trakcie otwierania — pomiń
        if (!containerRef.current?.contains(e.relatedTarget))
            save();
    }
    const sum = weekSum(task);
    return (react_1.default.createElement("span", { className: "scrum-rt d-inline-flex align-items-center", onClick: (e) => e.stopPropagation() },
        !editing && (react_1.default.createElement("span", { className: "scrum-inline-value", title: "Kliknij, aby wpisa\u0107 godziny dzienne (PO-PT)", onClick: () => setEditing(true) },
            sum > 0 ? `${sum} h` : "—",
            saving && " …")),
        react_1.default.createElement("div", { ref: containerRef, className: "scrum-week-hours" + (editing ? " open" : ""), onBlur: handleBlur }, DAYS.map((d, idx) => (react_1.default.createElement("input", { key: d.key, ref: idx === todayIdx ? focusInputRef : undefined, type: "number", min: 0, step: 0.25, tabIndex: editing ? 0 : -1, placeholder: d.placeholder, className: "form-control form-control-sm scrum-day-input", value: values[d.key] ?? "", onChange: (e) => setValues((prev) => ({ ...prev, [d.key]: e.target.value })), onKeyDown: (e) => {
                if (e.key === "Enter")
                    save();
                if (e.key === "Escape")
                    setEditing(false);
            } }))))));
}
